// page/auth/admin/modals/PositionEditModal.jsx
import React, { useEffect, useState } from "react";
import { api } from "../../../../util/api";
import { Stack, TextField } from "@mui/material";
import { notify } from "../../../../util/toast";
import { confirm as confirmDialog } from "../../../../util/confirmDialog";
import { runApiAction } from "../../../../util/apiFeedback";
import { API } from "../api/endpoints";
import FormField from "../../../../component/common/FormField";
import FormModal from "../../../../component/common/FormModal";
import ActionButton from "../../../../component/common/ActionButton";

export default function PositionEditModal({ open, onClose, initial, onSaved, onDeleted }) {
    const isEdit = !!initial;

    const [name, setName] = useState("");

    useEffect(() => {
        if (!open) return;
        setName(initial?.positionName || "");
    }, [open, initial]);

    const validate = () => {
        if (!name.trim()) return "직위/직급명은 필수입니다.";
        return null;
    };

    const save = () => {
        const msg = validate();
        if (msg) return notify(msg, "warning");

        return runApiAction({
            request: () => isEdit
                ? api.put(API.positions.update(initial.positionId), { positionName: name.trim() })
                : api.post(API.positions.create, { positionName: name.trim() }),
            successMsg: isEdit ? "직위/직급이 수정되었습니다." : "직위/직급이 생성되었습니다.",
            onSuccess: () => onSaved?.(),
        });
    };

    const handleDelete = async () => {
        if (!isEdit) return;
        if (!(await confirmDialog({ message: `직위/직급(${initial.positionName})을 삭제할까요?` }))) return;
        return runApiAction({
            request: () => api.delete(API.positions.delete(initial.positionId)),
            successMsg: "직위/직급이 삭제되었습니다.",
            onSuccess: () => (onDeleted ?? onClose)?.(),
        });
    };

    return (
        <FormModal
            open={open}
            onClose={onClose}
            title={isEdit ? "직위/직급 수정" : "직위/직급 생성"}
            subtitle={isEdit ? `ID: ${initial.positionId}` : undefined}
            maxWidth="sm"
            onSave={save}
            saveLabel={isEdit ? "수정" : "생성"}
            footerExtras={isEdit && (
                <ActionButton variant="delete" onClick={handleDelete} sx={{ fontSize: 12 }} />
            )}
        >
            <Stack spacing={1.25}>
                <FormField label="직위/직급명" required>
                    <TextField
                        autoFocus
                        fullWidth
                        size="small"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="직위/직급명을 입력하세요 (예: 대표이사·이사·과장·대리·주임·사원)"
                    />
                </FormField>
            </Stack>
        </FormModal>
    );
}
